'use strict';

var box = require('../../../../../../../../../../_virtual/box3.cjs');

var hasRequiredBox;

function requireBox () {
	if (hasRequiredBox) return box.__exports;
	hasRequiredBox = 1;

	var BOX_VARIANTS = /*#__PURE__*/ function(BOX_VARIANTS) {
	    BOX_VARIANTS["bordered"] = "bordered";
	    BOX_VARIANTS["borderless"] = "borderless";
	    return BOX_VARIANTS;
	}({});

	box.__exports.BOX_VARIANTS = BOX_VARIANTS;
	
	return box.__exports;
}

exports.__require = requireBox;
//# sourceMappingURL=box.cjs.map
